<template>
  <div>
    <custom-dialog width="407px" v-if="waitDialogObj.show" :visible="waitDialogObj.show">
      <div slot="header">
        <div class="header">
          <img :src="waitStatus[waitDialogObj.info.status].bgImg" class="bg-img">
          <div class="header-patient" :style="{ background: waitStatus[waitDialogObj.info.status].bgColor }">
            <span class="mr20">{{ waitDialogObj.info.patientName }}</span>
            <span class="mr20">{{ waitDialogObj.info.sex == '0' ? '男' : '女' }}</span>
            <span class="mr20">{{ waitDialogObj.info.age }}岁{{ waitDialogObj.info.ageMonth }}月</span>
            <span>{{ waitDialogObj.info.phone }}</span>
          </div>
        </div>
      </div>
      <div class="content" slot="content">
        <div>
          <span class="mr12">医生：{{ waitDialogObj.info.doctorName }}</span>
          <span>{{ computedDoctorVisit }}</span>
        </div>
        <div class="mt12">
          <span class="">号源：{{ waitDialogObj.info.schedulingTime }}</span>
          <span class="rigth-line">{{ waitDialogObj.info.schedulingTimeWeek }}</span>
          <span class="ml6">{{ waitDialogObj.info.appointmentStartTime }}-{{ waitDialogObj.info.appointmentEndTime
          }}</span>
          <span class="ml16" :style="{ color: waitStatus[waitDialogObj.info.status].color }">{{
            waitStatus[waitDialogObj.info.status].label }}</span>
        </div>
        <div class="mt12 price-item">金额：¥ {{ waitDialogObj.info.price }}</div>
        <div class="mt12 price-item">
          <span>实收：¥ {{ waitDialogObj.info.realPay }}</span>
          <span v-if="waitDialogObj.info.status == '0'" class="ml8 colorFE8F">待付</span>
          <span v-if="waitDialogObj.info.refundFlag" class="ml8 color6671">已退</span>
          <el-popover popper-class="price-popover"
            placement="top" width="203" trigger="hover">
            <i class="el-icon-question color9AA0 ml5" slot="reference"></i>
            <div>
              <div class="price-top">
                <div class="flex just-b">
                  <div>应收</div>
                  <div>¥{{ waitDialogObj.info.price }}</div>
                </div>
                <div class="flex just-b">
                  <div>实收</div>
                  <div>¥{{ waitDialogObj.info.realPay }}</div>
                </div>
              </div>
              <div class="price-bottom">
                  <div class="flex just-b">
                      <div>收费 {{waitDialogObj.info.payee}}</div>
                      <div class="color0000">¥{{waitDialogObj.info.realPay}}</div>
                  </div>
                  <div class="flex just-b">
                      <div>{{waitDialogObj.info.payTime}}</div>
                      <div>{{waitDialogObj.info.payWay | filterWay(PAY_WAY)}}</div>
                  </div>
              </div>
              <div class="price-bottom" v-if="waitDialogObj.info.refundFlag">
                <div class="flex just-b">
                  <div>退费 {{ waitDialogObj.info.refundBy }}</div>
                  <div class="color0000">¥{{ waitDialogObj.info.refundAmount }}</div>
                </div>
                <div class="flex just-b">
                  <div>{{ waitDialogObj.info.refundTime }}</div>
                  <div>{{waitDialogObj.info.refundWay | filterWay(PAY_WAY)}}</div>
                </div>
              </div>

            </div>
          </el-popover>
        </div>
      </div>
      <div class="footer" slot="footer">
        <custom-button v-if="[1].includes(waitDialogObj.info.status)" size="small" type="primary"
          @click="handleAdd">手动加号</custom-button>
        <custom-button size="small" type="info" @click="close">取消</custom-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { registerStatusList, doctorVisitList } from '@/utils/const'
import { dictText, debounce, msgboxWarning } from '@/utils/validateBase'
import { Utils } from '@/utils/utils'
import { CommonDTO } from '@/DTO/index'
import { imgArr } from '@/assets/images/img';
import { changeStandby } from '@/api/registration'
export default {
  // 定义引入的组件
  components: { CustomDialog },
  props: {
    waitDialogObj: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      registerStatusList: registerStatusList,//状态列表
      statusObj: {},//当前状态对象
      show: false,
      PAY_WAY: [],
      sourceConfigList: [],
      couponList: [],
      waitStatus: {
        '0': { label: '待支付', color: '#FE8F1F', bgImg: imgArr.statusBg1, bgColor: '#FFF9F3' },
        '1': { label: '候补中', color: '#FE8F1F', bgImg: imgArr.statusBg1, bgColor: '#FFF9F3' },
        '2': { label: '候补成功', color: '#29C01B', bgImg: imgArr.statusBg4, bgColor: '#F7FFF6' },
        '3': { label: '候补失败', color: '#667182', bgImg: imgArr.statusBg2, bgColor: '#FFF5F4' },
        '4': { label: '候补取消', color: '#667182', bgImg: imgArr.statusBg3, bgColor: '#F3FAFF' },
        '5': { label: '已退号', color: '#667182', bgImg: imgArr.statusBg3, bgColor: '#F3FAFF' },
      },
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  async created() {
    this.PAY_WAY = await CommonDTO.getPayWay()
  },
  filters: {
    filterWay(val, PAY_WAY) {
      return dictText(val, PAY_WAY)
    },
    filterReferrerType(val, list) {
      return list.find(item => { return item.id == val }) && list.find(item => { return item.id == val }).sourceName || ''
    }
  },
  computed: {
    //处理患者类型
    computedDoctorVisit() {
      return dictText(this.waitDialogObj.info.doctorVisit, doctorVisitList)
    },
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
   * 关闭
   */
    close() {
      this.$emit("close");
    },
    /**
     * 退号
     */
    refundRegister: debounce(async function () {
      this.$emit('refundRegister')
    }, 1000, true),
    handleAdd() {
      msgboxWarning(this, {
        title: '确定为该候补用户手动加号？',
        message: "该操作系统会自动为该用户加号，确定加号？",
        type: '',
        confirmFn: async () => {
          let { code, data } = await changeStandby({ id: this.waitDialogObj.info.id })
          if (code == 200) {
            this.$message.success('操作成功')
            this.$emit("close", true);
          }
        },
        cancelFn: () => {
        }
      })
    }
  },
}
</script>
<style lang="less">
.price-popover {
  background: #FFFDE9;
  padding: 10px;
  box-sizing: border-box;
  font-size: 13px;
  padding-bottom: 0;

  .price-top {
    padding-bottom: 8px;
    color: #000;
  }

  .price-bottom {
    border-top: 1px dashed #E0E0E0;
    padding-top: 8px;
    color: #667182;
    padding-bottom: 8px;
  }
}
</style>
<style lang="less" scoped>
.lockset-tips {
  height: 32px;
  background: #FFFDE9;
  line-height: 32px;
  text-align: center;
  font-weight: 400;
  color: #FE8F1F;
}

/deep/.el-dialog__body {
  padding-top: 0 !important;
}

.header {
  height: 56px;
  padding: 12px 16px;
  box-sizing: border-box;
  position: relative;

  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 407px;
    height: 56px;
  }

  .header-patient {
    position: relative;
    z-index: 2;
    padding: 6px 12px;
    box-sizing: border-box;
    color: #1F2329;
    font-size: 14px;
    border-radius: 2px;
  }
}

.content {
  color: #000;

  .rigth-line {
    padding-right: 6px;
    padding-left: 3px;
    border-right: 1px solid #EBEAEE;
    flex-grow: 0;
    flex-shrink: 0;

    &:last-child {
      border-right: none
    }

    &:first-child {
      padding-left: 0;
    }
  }
}

.footer {
  margin-top: 18px;
  padding-bottom: 16px;
  text-align: right;
  padding-right: 24px;

}

.footer-tips {
  color: #667182;
  margin-top: 18px;
  padding: 0 24px;
  padding-bottom: 16px;
}
</style>